import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import artistStyles from "views/Artists/Styles/ArtistStyles.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import SectionCarousel from "./Sections/DonReitzCarousel.jsx";
import SectionNavbars from "views/Components/Sections/SectionNavbars.jsx";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";


class Components extends React.Component {
  render() {

    const { classes} = this.props;

    return (     
      
      <div> 
        <SectionNavbars/>  
                 
        <Parallax image={require("assets/img/Eide/Cows.jpg")}>       

          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1 className={classes.title}>Eide Fine Art</h1>
                  <h4><b>With its display of contemporary ceramics, paintings, and sculpture, the Eide Art Gallery 465 is one of Northern Arizona's finest art venues. Works by recognized fine artists from the United States and other countries are showcased in the gallery. The adobe complex overlooks the Verde River in Lower Sycamore Canyon.</b></h4>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)} >
          <h3 className ={classNames(classes.subtitle)} style={artistStyles.bioText}>
              Don Reitz

             </h3>
          <p style={artistStyles.bioText}>Don Reitz is widely held by numerous professional ceramists as a "master of wheel thrown forms." His large sculptural vessels, bowls, and other works are legendary. Early recognition was for his large salt glazed forms with extruded clay enhancements including hand and tool impressions. In the last years of his life, he had an interest and skill in wood-firing which resulted in rich and subtle coloration and textures unique to the manipulation and spontaneity of fire and heat.
          </p>

          <SectionCarousel/>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(Components);



// WEBPACK FOOTER //
// ./src/views/Artists/DonReitz.jsx